import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { selectMenus } from "../../../../../redux/editorSlice";
import { MENU_TYPES } from "../../../../../constants";
import { useState } from "react";
import { logoutUser } from "../../../../../redux/WithcookieSlice";

const MobileNavMenu = () => {
  const { t } = useTranslation();
  const menus = useSelector(selectMenus);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // 열린 메뉴 ID 추적을 위한 상태 추가
  const [openMenus, setOpenMenus] = useState([]);
  
  // 주 메뉴만 필터링 (표시 가능한 메뉴만) - 글로벌 메뉴는 표시하지 않음
  const mainMenus = menus.filter(
    menu => menu.type === MENU_TYPES.MAIN && 
    menu.visible !== false && 
    !menu.parentId // 최상위 메뉴만
  ).sort((a, b) => a.order - b.order);
  
  // 메뉴 자식 항목 찾기 함수 - 글로벌 메뉴의 자식도 제외
  const getChildMenus = (parentId) => {
    return menus
      .filter(menu => 
        menu.parentId === parentId && 
        menu.visible !== false &&
        menu.type === MENU_TYPES.MAIN // 글로벌 메뉴의 자식은 표시하지 않음
      )
      .sort((a, b) => a.order - b.order);
  };
  
  // 모바일 메뉴 닫기 함수
  const closeMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector("#offcanvas-mobile-menu");
    if (offcanvasMobileMenu) {
      offcanvasMobileMenu.classList.remove("active");
      document.body.classList.remove("menu-open");
      
      // 햄버거 메뉴 버튼에서 active 클래스 제거
      document.querySelectorAll('.hamburger-menu').forEach(hamburger => {
        hamburger.classList.remove('active');
      });
    }
  };
  
  // 메뉴 클릭 핸들러
  const handleMenuClick = (e, menu) => {
    e.preventDefault();
    
    // 메뉴 액션 처리
    if (menu.menuAction === 'logout') {
      dispatch(logoutUser()).then(() => {
        // 로그아웃 성공 후 홈 페이지로 이동
        navigate('/');
        closeMobileMenu(); // 메뉴 닫기 추가
      });
      return;
    }
    
    // 외부 링크 처리
    if (menu.externalLink) {
      window.open(menu.externalLink, '_blank');
      closeMobileMenu(); // 메뉴 닫기 추가
      return;
    }
    
    // 일반 내부 링크 처리
    navigate(menu.path || '/');
    closeMobileMenu(); // 메뉴 닫기 추가
  };
  
  // 메뉴 토글 핸들러
  const toggleMenu = (menuId, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (openMenus.includes(menuId)) {
      setOpenMenus(openMenus.filter(id => id !== menuId));
    } else {
      setOpenMenus([...openMenus, menuId]);
    }
  };
  
  // 메뉴 항목 재귀적 렌더링
  const renderMenuItems = (items, depth = 0) => {
    return items.map(menu => {
      const children = getChildMenus(menu.id);
      const hasChildren = children.length > 0;
      const isOpen = openMenus.includes(menu.id);
      
      return (
        <li key={menu.id} className={`${hasChildren ? "menu-item-has-children" : ""} ${isOpen ? "active" : ""}`}>
          {menu.externalLink || menu.menuAction ? (
            // 외부 링크나 특수 액션이 있는 메뉴
            <a href="#" onClick={(e) => handleMenuClick(e, menu)}>
              {menu.name}
            </a>
          ) : (
            // 일반 내부 링크 메뉴
            <Link to={menu.path || "/"} onClick={(e) => {
              // Link 기본 동작을 막고 수동으로 navigate 처리
              e.preventDefault();
              handleMenuClick(e, menu);
            }}>
              {menu.name}
            </Link>
          )}
          
          {hasChildren && (
            <>
              <span className="menu-expand" onClick={(e) => toggleMenu(menu.id, e)}>
                <i className="fa fa-angle-down"></i>
              </span>
              <ul className={`sub-menu ${isOpen ? "sub-menu-active" : ""}`}>
                {renderMenuItems(children, depth + 1)}
              </ul>
            </>
          )}
        </li>
      );
    });
  };

  return (
    <nav className="offcanvas-navigation" id="offcanvas-navigation">
      <ul>
        {mainMenus.length > 0 ? (
          <>
            {/* 홈 메뉴가 없는 경우, 기본 홈 메뉴 추가 */}
            {!mainMenus.some(menu => menu.path === '/') && (
              <li>
                <Link to="/" onClick={(e) => {
                  e.preventDefault();
                  navigate('/');
                  closeMobileMenu();
                }}>홈</Link>
              </li>
            )}
            {renderMenuItems(mainMenus)}
          </>
        ) : (
          // 메뉴가 없는 경우 기본 홈 메뉴만 표시
          <li>
            <Link to="/" onClick={(e) => {
              e.preventDefault();
              navigate('/');
              closeMobileMenu();
            }}>홈</Link>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default MobileNavMenu;
